
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vant from 'vant';
import echarts from 'echarts'
import './assets/rem'
import 'vant/lib/index.css';
import router from './router'
import store from './store'
import {get, post} from './http'
import cmsComponents from "./cmscomponents/index";
// import wx from 'weixin-js-sdk'
import { parseTime,timeFormat} from "../utils/time";
import './assets/icons/iconfont/iconfont.css'
import publicJs from './assets/public'
import publicUpload from './assets/upload/upload'
import filters from './filters/index'


//真机调试 （电脑调试、打包的时候 要隐掉）
// import Vconsole from 'vconsole'
//  let vConsole = new Vconsole()
//  Vue.use(vConsole)

// Vue.use(wx);
Vue.use(Vant);
Vue.use(cmsComponents)

import Mui from 'vue-awesome-mui'
Vue.use(Mui)

// 注入全局过滤器
Object.keys(filters).forEach(item => {
  Vue.filter(item, filters[item])
})

Vue.prototype.parseTime = parseTime
Vue.prototype.timeFormat = timeFormat
Vue.config.productionTip = false
// 全局事件总线对象
Vue.prototype.$bus = new Vue()
Vue.prototype.$echarts = echarts
Vue.prototype.$httpGet = get
Vue.prototype.$httpPost = post
Vue.prototype.$publicJs = publicJs
Vue.prototype.$publicUpload = publicUpload

// 跳转路由
Vue.prototype.$goRoute = function (name, query) {
  this.$router.push({
    name: name,
    query: query
  })
}


// 路由退回
Vue.prototype.$backRoute = function (length) {
  length = length === undefined ? -1 : -length
  this.$router.go(length)
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
Vue.filter('select',(e,st,type) =>{
  var arr = ''
  if(e.length > 0){
    if(st.length == 0 ) return arr = ''
    if(type == 'retype'){
      st.forEach((item,index)=>{
        if(item.value == e){
          arr = item.label
          return arr
          }
      })

    }else {
      e.forEach((item,index)=>{
        st.forEach((items,indexs)=>{
          if(item == items.id){
            arr = items.name+'; '+arr
          }
        })
      })
    }
    return arr
  }else {
    return ''
  }

})



// WEBPACK FOOTER //
// ./src/main.js